import { getScreenAd, IS_CLIENT } from "@/common/api";
import { IAdData } from "@/common/interface";
import Link from "@/components/common/Link";
import Download from "@/components/common/Download";
import { preload } from "@q/safeUtil";
import React, {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import "./index.scss";
import { callClient, OpenType } from "@q/softCore";
import { INSTALL_PROMISE } from "@/utils/appInstall";
import { ICategorys } from "@/common/interface";
import { useInViewport } from "ahooks";
import { sendClkLog } from "@/common/selfMonitor";
import { comMonitor, replaceUrlTemplate } from "@/utils/com";
import { formatDate } from "@/utils/date";

interface IProps {
  data: IAdData;
  position?: string;
}

interface TimeDown {
  showTimeDown: boolean;
  closeCallback?: () => void;
  ref?: Record<string, any>;
}
const screenAd = (show: number) => {
  if (IS_CLIENT) {
    callClient("screenAdShow", show);
  }
};

/* eslint-disable-next-line react/display-name */
const TimeDown = forwardRef((props: TimeDown, ref: any) => {
  const { showTimeDown, closeCallback } = props;
  const [second, setSecond] = useState(5);
  const timerRef = useRef<number>();
  const secondRef = useRef<number>(5);
  const onClick = () => {
    timerRef.current && clearInterval(timerRef.current);
    closeCallback && closeCallback();
  };
  useImperativeHandle(ref, () => ({
    clearTimer: () => timerRef.current && clearInterval(timerRef.current),
  }));
  useEffect(() => {
    if (typeof timerRef.current === "number") {
      return;
    }
    monitor &&
      monitor.log({
        c: "展现开屏广告",
      });
    if (!showTimeDown) return;
    timerRef.current = window.setInterval(() => {
      if (secondRef.current > 0) {
        secondRef.current -= 1;
        setSecond(secondRef.current);
      } else {
        onClick();
        clearInterval(timerRef.current);
      }
    }, 1000);
  });
  return (
    <a className="screen-ad__close" onClick={onClick} data-text="关闭开屏广告">
      {showTimeDown ? `${second}秒跳过` : "关闭"}
    </a>
  );
});

const ScreenAd: React.FC<IProps> = (props) => {
  const { data, position } = props;
  if (!data || !data.soft_id) {
    return null;
  }
  const isSeAd = data.category === "1";

  const [show, setShow] = useState(false);
  const [img, setImg] = useState("");
  const timeDownRef = useRef<any>();

  const nodeRef = useRef<HTMLDivElement>(null);
  const [lock, setLock] = useState(false);
  const [inViewport, ratio] = useInViewport(nodeRef, {
    threshold: [0.1, 0.5, 1],
  });

  const closeCallback = () => {
    if (timeDownRef.current && timeDownRef.current.clearTimer)
      timeDownRef.current.clearTimer();
    setShow(false);
  };

  useEffect(() => {
    // const adId = data.ad_id;

    // if (data.startTime && data.endTime) {
    //   const start = +new Date(data.startTime);
    //   const end = +new Date(data.endTime);
    //   const now = +new Date();

    //   if (now > end || now < start) {
    //     screenAd(0);
    //     return;
    //   }
    // }

    const softIds: number[] = data.instsoftid
      ? data.instsoftid.split("|").map((item) => Number(item))
      : [];

    const isShowScreen = (expression: boolean) => {
      if (expression) {
        preload(data.url).then(() => {
          setImg(data.url);
          screenAd(1);
          setShow(true);
        });
      } else {
        screenAd(0);
      }
    };

    const createAdType = () => {
      return `${data.ad_id}`;
    };

    const isOpened = () => {
      let localData;
      try {
        localData = JSON.parse(
          window.localStorage.getItem(`isOpenComAd${position}`) || "",
        );
      } catch (e) {
        localData = null;
      }

      if (!localData) {
        return false;
      }
      const date = formatDate();
      if (localData.date < date) {
        window.localStorage.removeItem(`isOpenComAd${position}`);
        localData = null;
      }
      if (localData && localData.tag) {
        return true;
      }
      return false;
    };

    if (isOpened()) {
      return;
    }
    if (data.isCom && !isOpened()) {
      isShowScreen(true);
      // 存入缓存
      window.localStorage.setItem(
        `isOpenComAd${position}`,
        JSON.stringify({
          tag: true,
          date: formatDate(),
          position,
        }),
      );
    } else {
      getScreenAd({
        ad_type: createAdType(),
        // ad_type: data.ad_id,
      }).then((res) => {
        // res.errno = 0;
        if (softIds.length) {
          INSTALL_PROMISE(softIds).then((isInstalled) => {
            // 客户端扫描时间很长，接口等扫描完成在调用
            isShowScreen(!!(res.errno === 0 && !isInstalled && data.url));
          });
        } else {
          isShowScreen(!!(res.errno === 0 && data.url));
        }
        // console.log("data url", data.url);
        // isShowScreen(!!(res.errno === 0 && data.url));
      });
    }
  }, [data, position]);

  useEffect(() => {
    if (inViewport && !lock && ratio == 1 && show) {
      const params = {
        cid: position, //事件名称组名
        title: `${data.soft_id}$${data.name}$${
          data.category && data.category.length
            ? ICategorys[data.category]
            : ICategorys[1]
        }`,
      };
      sendClkLog(params, "track");
      setLock(true);
      if (data.imptk && Array.isArray(data.imptk)) {
        data.imptk.forEach((item) => {
          comMonitor(item);
        });
      }
    }
  }, [inViewport, data, lock, ratio, show, position]);
  const [startTime, setStartTime] = useState(0);
  if (!show) {
    return null;
  }

  const categoryText =
    data.category && data.category.length > 0
      ? `${ICategorys[data.category]}`
      : `${ICategorys[1]}`;

  const onMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setStartTime(Date.now());
  };

  const onMouseUp = (e: React.MouseEvent) => {
    if (Array.isArray(data.clktk) && data.clktk.length) {
      const now = Date.now();
      data.clktk.forEach((url) => {
        const realUrl = replaceUrlTemplate(url, e, startTime, now);
        comMonitor(realUrl);
      });
    }
  };
  const cptItem = (
    <div
      className="screen-ad__link"
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
    >
      <Link
        softId={data.soft_id}
        href={data.href || "javaScript:;"}
        openType={data.open_type || OpenType.openWithClient}
        exec={data.exec}
        dataText={categoryText}
        ads={data.ads}
        position={position}
        category={data.category}
        comAds={data.clktk}
        name={data.name}
      >
        <img className="screen-ad__img" src={img} />
      </Link>
    </div>
  );
  const seItem = (
    <Download
      className="screen-ad__link"
      softId={data.soft_id}
      href={data.href || "javaScript:;"}
      openType={data.open_type || OpenType.openWithClient}
      exec={data.exec}
      dataText={categoryText}
      ads={data.ads}
      callback={closeCallback}
      position={position}
      category={data.category}
    >
      <img className="screen-ad__img" src={img} />
    </Download>
  );
  const item = isSeAd ? seItem : cptItem;
  return (
    <div ref={nodeRef} className="screen-ad__mask" data-bk="开屏广告">
      <TimeDown
        ref={timeDownRef}
        showTimeDown={!isSeAd || data.countdown != 0}
        closeCallback={closeCallback}
      />
      {item}
    </div>
  );
};

export default ScreenAd;
